import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { trackEvent } from '../../hooks/useMetaPixel';
interface GoldButtonProps extends HTMLMotionProps<'button'> {
  children: ReactNode;
  className?: string;
  fullWidth?: boolean;
  scrollTo?: string;
  href?: string;
}
export function GoldButton({
  children,
  className = '',
  fullWidth = false,
  scrollTo,
  href,
  onClick,
  ...props
}: GoldButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (href) {
      trackEvent('AddToCart');
      window.open(href, '_blank', 'noopener,noreferrer');
    }
    if (scrollTo) {
      const target = document.querySelector(scrollTo);
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth'
        });
      }
    }
    onClick?.(e);
  };
  return <motion.button whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} className={`
        bg-gold-gradient text-dark-900 font-bold py-4 px-8 rounded-lg shadow-lg 
        uppercase tracking-wider text-lg transition-all duration-300
        hover:shadow-[0_0_20px_rgba(212,168,83,0.4)]
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} onClick={handleClick} {...props} data-id="element-101">
      {children}
    </motion.button>;
}